<script setup lang="ts">
import { pInputVariants } from '@ui/components/core/p-input/index.js';
import type { PInputProps } from '@ui/components/core/p-input/PInputProps.js';
import { cn } from '@ui/lib/utils.js';
import { useVModel } from '@vueuse/core';
import { ref } from 'vue';

const props = withDefaults(defineProps<PInputProps>(), {
    type: 'text',
});

const emits = defineEmits<{
    (e: 'update:modelValue', payload: string | number): void;
}>();

const modelValue = useVModel(props, 'modelValue', emits, {
    passive: true,
    defaultValue: props.defaultValue,
});

const inputEl = ref<HTMLInputElement | null>(null);

defineExpose({ inputEl });
</script>

<template>
    <input
        ref="inputEl"
        v-model="modelValue"
        data-slot="input"
        :class="cn(pInputVariants({ size }), props.rounded ? 'rounded-full' : '', props.class)"
        :type="type"
    />
</template>
